module.exports = __webpack_public_path__ + "img/streaming_kupid.09643b99.svg";